/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type PreviewKind = "A_ROLE" | "BACKGROUND" | "BADGE_DARK" | "BADGE_LIGHT" | "B_ROLE" | "CAROUSEL" | "DETAIL_BACKGROUND" | "EXCERPT" | "HEADSHOT" | "HERO" | "HERO_LOGO" | "LOGO" | "PORTRAIT" | "SQUARE" | "%future added value";
export type TopLevelMediaKind = "APPLICATION" | "AUDIO" | "DOCUMENT" | "IMAGE" | "TEXT" | "VIDEO" | "%future added value";
export type featuredListQueryVariables = {
    readonly id: string;
};
export type featuredListQueryResponse = {
    readonly list: {
        readonly errors: ReadonlyArray<{
            readonly created: unknown | null;
            readonly id: string;
            readonly location: string | null;
            readonly type: string | null;
        } | null> | null;
        readonly hasErrors: boolean | null;
        readonly list: ({
            readonly __typename: string;
            readonly description?: string | null;
            readonly id?: string;
            readonly label?: string | null;
            readonly name?: string | null;
            readonly previews?: {
                readonly edges: ReadonlyArray<{
                    readonly preview: {
                        readonly mediaAsset: {
                            readonly id: string;
                            readonly files: ReadonlyArray<{
                                readonly name: string | null;
                                readonly path: string | null;
                            }> | null;
                            readonly topLevelMediaType: {
                                readonly kind: TopLevelMediaKind | null;
                            } | null;
                        } | null;
                        readonly link: string | null;
                        readonly kind: PreviewKind | null;
                    } | null;
                }> | null;
            } | null;
            readonly subTitle?: string | null;
            readonly title?: string | null;
            readonly landingPageUrl?: string | null;
            readonly badges?: ReadonlyArray<{
                readonly imageLink: string | null;
                readonly link: string | null;
                readonly previews: {
                    readonly count: number | null;
                    readonly edges: ReadonlyArray<{
                        readonly cursor: string | null;
                        readonly preview: {
                            readonly link: string | null;
                            readonly kind: PreviewKind | null;
                            readonly mediaAsset: {
                                readonly files: ReadonlyArray<{
                                    readonly name: string | null;
                                    readonly path: string | null;
                                }> | null;
                                readonly topLevelMediaType: {
                                    readonly kind: TopLevelMediaKind | null;
                                } | null;
                            } | null;
                        } | null;
                    }> | null;
                } | null;
            }> | null;
            readonly revision?: string | null;
        } & ({
            readonly __typename: "DynamicList";
            readonly description: string | null;
            readonly id: string;
            readonly label: string | null;
            readonly name: string | null;
            readonly previews: {
                readonly edges: ReadonlyArray<{
                    readonly preview: {
                        readonly mediaAsset: {
                            readonly id: string;
                            readonly files: ReadonlyArray<{
                                readonly name: string | null;
                                readonly path: string | null;
                            }> | null;
                            readonly topLevelMediaType: {
                                readonly kind: TopLevelMediaKind | null;
                            } | null;
                        } | null;
                        readonly link: string | null;
                        readonly kind: PreviewKind | null;
                    } | null;
                }> | null;
            } | null;
            readonly subTitle: string | null;
            readonly title: string | null;
        } | {
            readonly __typename: "FixedList";
            readonly landingPageUrl: string | null;
            readonly badges: ReadonlyArray<{
                readonly imageLink: string | null;
                readonly link: string | null;
                readonly previews: {
                    readonly count: number | null;
                    readonly edges: ReadonlyArray<{
                        readonly cursor: string | null;
                        readonly preview: {
                            readonly link: string | null;
                            readonly kind: PreviewKind | null;
                            readonly mediaAsset: {
                                readonly files: ReadonlyArray<{
                                    readonly name: string | null;
                                    readonly path: string | null;
                                }> | null;
                                readonly topLevelMediaType: {
                                    readonly kind: TopLevelMediaKind | null;
                                } | null;
                            } | null;
                        } | null;
                    }> | null;
                } | null;
            }> | null;
            readonly revision: string | null;
        } | {
            /*This will never be '% other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        })) | null;
    } | null;
};
export type featuredListQuery = {
    readonly response: featuredListQueryResponse;
    readonly variables: featuredListQueryVariables;
};



/*
query featuredListQuery(
  $id: ID!
) {
  list(id: $id) {
    errors {
      created
      id
      location
      type
    }
    hasErrors
    list {
      __typename
      ... on DynamicList {
        description
        id
        label
        name
        previews {
          edges {
            preview {
              mediaAsset {
                id
                files {
                  name
                  path
                  id
                }
                topLevelMediaType {
                  kind
                  id
                }
              }
              link
              kind
            }
          }
        }
        subTitle
        title
      }
      ... on FixedList {
        description
        id
        landingPageUrl
        badges {
          imageLink
          link
          previews {
            count
            edges {
              cursor
              preview {
                link
                kind
                mediaAsset {
                  files {
                    name
                    path
                    id
                  }
                  topLevelMediaType {
                    kind
                    id
                  }
                  id
                }
              }
            }
          }
          id
        }
        label
        name
        previews {
          edges {
            preview {
              link
              kind
              mediaAsset {
                id
                files {
                  name
                  path
                  id
                }
                topLevelMediaType {
                  kind
                  id
                }
              }
            }
          }
        }
        subTitle
        title
        revision
      }
      ... on Node {
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "errors",
  "storageKey": null,
  "args": null,
  "concreteType": "Error",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "created",
      "args": null,
      "storageKey": null
    },
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "location",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasErrors",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "label",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "path",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "files",
  "storageKey": null,
  "args": null,
  "concreteType": "MediaAssetFile",
  "plural": true,
  "selections": [
    (v8/*: any*/),
    (v9/*: any*/)
  ]
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "kind",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "topLevelMediaType",
  "storageKey": null,
  "args": null,
  "concreteType": "TopLevelMediaType",
  "plural": false,
  "selections": [
    (v11/*: any*/)
  ]
},
v13 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "mediaAsset",
  "storageKey": null,
  "args": null,
  "concreteType": "MediaAsset",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v10/*: any*/),
    (v12/*: any*/)
  ]
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "link",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "subTitle",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "landingPageUrl",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "imageLink",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "revision",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "files",
  "storageKey": null,
  "args": null,
  "concreteType": "MediaAssetFile",
  "plural": true,
  "selections": [
    (v8/*: any*/),
    (v9/*: any*/),
    (v2/*: any*/)
  ]
},
v23 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "topLevelMediaType",
  "storageKey": null,
  "args": null,
  "concreteType": "TopLevelMediaType",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    (v2/*: any*/)
  ]
},
v24 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "mediaAsset",
  "storageKey": null,
  "args": null,
  "concreteType": "MediaAsset",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v22/*: any*/),
    (v23/*: any*/)
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "featuredListQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "list",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ListPayload",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "list",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "InlineFragment",
                "type": "DynamicList",
                "selections": [
                  (v6/*: any*/),
                  (v2/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "previews",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PreviewsConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PreviewEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "preview",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Preview",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v11/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v15/*: any*/),
                  (v16/*: any*/)
                ]
              },
              {
                "kind": "InlineFragment",
                "type": "FixedList",
                "selections": [
                  (v6/*: any*/),
                  (v2/*: any*/),
                  (v17/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "badges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Badge",
                    "plural": true,
                    "selections": [
                      (v18/*: any*/),
                      (v14/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "previews",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PreviewsConnection",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PreviewEdge",
                            "plural": true,
                            "selections": [
                              (v20/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "preview",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Preview",
                                "plural": false,
                                "selections": [
                                  (v14/*: any*/),
                                  (v11/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "mediaAsset",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "MediaAsset",
                                    "plural": false,
                                    "selections": [
                                      (v10/*: any*/),
                                      (v12/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "previews",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PreviewsConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PreviewEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "preview",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Preview",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              (v11/*: any*/),
                              (v13/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v21/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "featuredListQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "list",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ListPayload",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "list",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "type": "DynamicList",
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "previews",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PreviewsConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PreviewEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "preview",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Preview",
                            "plural": false,
                            "selections": [
                              (v24/*: any*/),
                              (v14/*: any*/),
                              (v11/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v15/*: any*/),
                  (v16/*: any*/)
                ]
              },
              {
                "kind": "InlineFragment",
                "type": "FixedList",
                "selections": [
                  (v6/*: any*/),
                  (v17/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "badges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Badge",
                    "plural": true,
                    "selections": [
                      (v18/*: any*/),
                      (v14/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "previews",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PreviewsConnection",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PreviewEdge",
                            "plural": true,
                            "selections": [
                              (v20/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "preview",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Preview",
                                "plural": false,
                                "selections": [
                                  (v14/*: any*/),
                                  (v11/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "mediaAsset",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "MediaAsset",
                                    "plural": false,
                                    "selections": [
                                      (v22/*: any*/),
                                      (v23/*: any*/),
                                      (v2/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v2/*: any*/)
                    ]
                  },
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "previews",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PreviewsConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PreviewEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "preview",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Preview",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              (v11/*: any*/),
                              (v24/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v21/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "featuredListQuery",
    "id": null,
    "text": "query featuredListQuery(\n  $id: ID!\n) {\n  list(id: $id) {\n    errors {\n      created\n      id\n      location\n      type\n    }\n    hasErrors\n    list {\n      __typename\n      ... on DynamicList {\n        description\n        id\n        label\n        name\n        previews {\n          edges {\n            preview {\n              mediaAsset {\n                id\n                files {\n                  name\n                  path\n                  id\n                }\n                topLevelMediaType {\n                  kind\n                  id\n                }\n              }\n              link\n              kind\n            }\n          }\n        }\n        subTitle\n        title\n      }\n      ... on FixedList {\n        description\n        id\n        landingPageUrl\n        badges {\n          imageLink\n          link\n          previews {\n            count\n            edges {\n              cursor\n              preview {\n                link\n                kind\n                mediaAsset {\n                  files {\n                    name\n                    path\n                    id\n                  }\n                  topLevelMediaType {\n                    kind\n                    id\n                  }\n                  id\n                }\n              }\n            }\n          }\n          id\n        }\n        label\n        name\n        previews {\n          edges {\n            preview {\n              link\n              kind\n              mediaAsset {\n                id\n                files {\n                  name\n                  path\n                  id\n                }\n                topLevelMediaType {\n                  kind\n                  id\n                }\n              }\n            }\n          }\n        }\n        subTitle\n        title\n        revision\n      }\n      ... on Node {\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = 'bffeac8965e2343621dd7fbe680ef377';
export default node;
